// Wave 14 — single source of truth for the per-position chip colors used
// across the analytics surfaces (SessionDetail, Dashboard, future
// surfaces). Previously duplicated inline in SessionDetail.tsx and
// PositionsAnalytics.tsx; extracted here so charts in the new
// Dashboard share the same palette without copying.

import { colors } from '../theme';

export const POSITION_COLORS: Record<string, string> = {
  drops: '#6affff',
  hoods: '#6aff45',
  tops: '#ffd166',
  upright: '#ffd166',
  aero_tuck: '#ff7ad9',
  aero_bars: '#ff6a45',
  tt: '#a18dff',
  standing: '#ff9a3c',
  sprint: '#ff5a5f',
};

export function positionColor(cls: string | null | undefined): string {
  if (!cls) return colors.textMuted;
  return POSITION_COLORS[cls] ?? colors.textMuted;
}
